import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    HasOnError,
} from "@insite/client-framework/HandlerCreator";
import { getBranchCollection, BranchCollectionModel } from "@tCentro/Services/CENAdminBranchService";
import { BrandListModel, getBrandList } from "@tCentro/Services/CENAdminBrandListService";
import { BrandsCollectionModel, getBrandsCollection } from "@tCentro/Services/CENAdminBrandsService";

export interface GetBrandListParameter extends HasOnSuccess<BrandListModel>, HasOnError<string> {
    page?: number;
    pageSize?: number;
    query?: string;
}

type HandlerType = ApiHandler<GetBrandListParameter, { apiResult: BrandListModel }>;

export const GetBrandsList: HandlerType = async props => {
    try {
const result = await getBrandList(props.parameter.page, props.parameter.pageSize,props.parameter.query);
        if (props.parameter.onSuccess) {
            props.parameter.onSuccess(result);
        }
    } catch (error: any) {
        if (props.parameter.onError) {
            props.parameter.onError(error?.message ?? "Failed to load branches");
        }
    }
};

export const chain = [GetBrandsList];
const getBrandsList = createHandlerChainRunner(chain, "getBrandsList");
export default getBrandsList;
